import { Fragment, useState } from "react";
import { useBudgets } from "../../../hooks/finances/useBudgets";
import BudgetCard from "../cards/finances/BudgetCard";
import BudgetDetailsModal from "../popup/finances/BudgetDetailsModal";
import GhostTransactionsCarousel from "../loading/skeletons/GhostTransactionCarousel";
import BaseCarousel from "./common/BaseCarousel";
import FiInsightCard from "../../../pages/private/financial-insights/common/FiInsightCard";
import { useNavigate } from "react-router-dom";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { PERSONAL_FINANCES_SCHEMA } from "../../../utils/schemas/language/pages/personalFinancesSchema";

function BudgetCarousel() {
  const content = getLanguageContent(PERSONAL_FINANCES_SCHEMA);
  const { isLoading, budgets } = useBudgets();
  const [selectedBudget, setSelectedBudget] = useState(null);

  const navigate = useNavigate();

  const hasNoBudgets = !isLoading && (!budgets || budgets.length === 0);

  return (
    <Fragment>
      {hasNoBudgets ? (
        <div
          className="budget-carousel-empty-insight mobile-white-box"
          style={{ marginBottom: "24px" }}
        >
          <FiInsightCard
            title={content.budgeting.overall_usage.empty_insight.title}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                marginTop: "8px",
              }}
            >
              <p
                className="reset-margin"
                style={{
                  color: "#6b7280",
                  fontSize: "14px",
                  lineHeight: "1.5",
                  margin: 0,
                }}
              >
                {content.budgeting.overall_usage.empty_insight.description}
              </p>
              <div>
                <button
                  className="cta-button primary rounded small"
                  onClick={() =>
                    navigate("/finances/personal-finances/budgets")
                  }
                  style={{ width: "fit-content" }}
                >
                  {content.budgeting.overall_usage.empty_insight.cta}
                </button>
              </div>
            </div>
          </FiInsightCard>
        </div>
      ) : (
        <BaseCarousel
          title={content.overview.budgets.title}
          seeAllPath="/finances/personal-finances/budgets"
          seeAllText={content.global.see_all}
          items={budgets}
          isLoading={isLoading}
          emptyMsg={content.overview.budgets.empty_title}
          previousAlt={content.global.previous}
          nextAlt={content.global.next}
          containerClassName="mobile-white-box"
          /* Parameterized Ghost */
          GhostComponent={
            <GhostTransactionsCarousel count={3} showPagination={false} />
          }
          renderItem={(budget) => (
            <BudgetCard
              key={budget.uuid}
              budget={budget}
              onClick={() => setSelectedBudget(budget)}
            />
          )}
        />
      )}

      {selectedBudget && (
        <BudgetDetailsModal
          budget={selectedBudget}
          onClose={() => setSelectedBudget(null)}
          copy={content.budgeting.details}
        />
      )}
    </Fragment>
  );
}

export default BudgetCarousel;
